import { render } from "./index.vue?vue&type=template&id=5c9c600c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.less?vue&type=style&index=0&id=5c9c600c&scoped=true&lang=less"

import exportComponent from "/Users/jinzhouhang/work/zhanhai/ypin-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c9c600c"]])

export default __exports__